import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentcolor",
      "fill-rule": "evenodd",
      d: "M2.278 3.09A7.417 7.417 0 0 1 14.94 8.333c0 .841-.09 1.578-.32 2.274-.232.7-.594 1.32-1.095 1.945a.777.777 0 0 1-.018.022l-5.417 6.25a.75.75 0 0 1-1.133 0l-5.417-6.25a.792.792 0 0 1-.018-.022c-.501-.625-.863-1.246-1.095-1.945-.23-.696-.32-1.433-.32-2.274 0-1.967.781-3.854 2.172-5.245Zm5.245-.673a5.917 5.917 0 0 0-5.917 5.917c0 .735.078 1.302.244 1.802.163.492.423.955.832 1.468l4.84 5.585 4.84-5.585c.41-.513.67-.976.833-1.468.166-.5.244-1.067.244-1.802a5.917 5.917 0 0 0-5.917-5.917Zm0 4.167a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Zm-3.25 1.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "address"}) } }